import { useAuthBearerFetch } from "matsuri-hooks"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { m2mCleaning_cleanerV3 } from "@/endpoints/m2m-cleaning.cleaner-v3"

interface PlacementAddressByOperationIdOutput {
    address: string
}

export const usePlacementAddressByOperationId = (operationId?: string) => {
    const { token } = useAuth()

    const endpoint = m2mCleaning_cleanerV3.getPlacementAddressByCleaningId
    return useAuthBearerFetch<PlacementAddressByOperationIdOutput>(
        token,
        operationId ? endpoint({ cleaningId: operationId }) : null,
        {
            method: endpoint.method
        }
    )
}
